import React from 'react';
import propTypes from 'prop-types';
import MinimizedPanel from '../MinimizedPanel';

import style from './index.scss';
/**
 * This components are using when the data is Loading or its in Loading state
 * @props onTogglePanelVisibility
 * @props onReload
 * @props noDataText
 * @props title
 * @props reloadDataText
 * @props isLoadingDataText
 * @props isCollapsed
 */

const NoDataIsLoadingWrapper = (props) => {
  const {
    onTogglePanelVisibility,
    onReload,
    noDataText,
    title,
    reloadDataText,
    isLoadingDataText,
    isCollapsed
  } = props;
  return (
    <div className="card">
      <MinimizedPanel
        onTogglePanelVisibility={onTogglePanelVisibility}
        title={title}
        isCollapsed={isCollapsed}>
        {props.children}
      </MinimizedPanel>
      <div className="card-body">
        <div className="row">
          <div className="col-md-12">
            {noDataText && <p>{noDataText}</p>}
            {reloadDataText && (
              <p>
                <a className={style.retryLink} onClick={onReload}>
                  {reloadDataText}
                </a>
              </p>
            )}
            {isLoadingDataText && <p>{isLoadingDataText}</p>}
          </div>
        </div>
      </div>
    </div>
  );
};
/**
 * Proptypes
 * @type {idx,name,score,comparison}
 */
NoDataIsLoadingWrapper.propTypes = {
  onTogglePanelVisibility: propTypes.string,
  onReload: propTypes.string,
  noDataText: propTypes.string,
  title: propTypes.string,
  reloadDataText: propTypes.string,
  isLoadingDataText: propTypes.string,
  isCollapsed: propTypes.bool
};
export default NoDataIsLoadingWrapper;
